import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../../parts/intermediatePart";
import {ShowerBodyType} from "../../constants";
import {Shower} from "../../parts/shower";
import { getMetadataByDimensions } from "../../../../../misc/utils";
import {Vanity} from "../../parts/vanity";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";

export default class Threshold extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'threshold';
    this.partName = 'Threshold';
    this.translateId = "visualizer.bathroom.shower.threshold";
    this.homePageTitle = 'Threshold';
    this.dbName = 'ShowerPan';
    this.isStoneFeature = true;
    this.selectedByUser = false;
    this.shadowName = "Pan";
    this.layerPriority = 7;
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = true;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const parent = this.getParent();
    const shower = parent.getParent();
    if ((!shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();

    this.getParent().selectedByUser = true;
    const showerFloor = shower.showerFloor;
    if (showerFloor && !showerFloor.selectedByUser) {
      const showerFloorAvailableFeatures = showerFloor.navigationSubItems();
      const currentThresholdName = this.getSplittedFeatureName();
      const sameShowerFloor = showerFloorAvailableFeatures.find(navItemFloor => {
        return navItemFloor.part.getSplittedFeatureName() === currentThresholdName
      });
      if (sameShowerFloor) {
        super.handleClick.call(sameShowerFloor.part);
        showerFloor.selectedByUser = false;
      }
    }
  }

  load(dbFeature) {
    if (dbFeature.metaData) {
      if(Array.isArray(dbFeature.metaData["EX L"])) {
        if (dbFeature.metaData["EX L"].includes("Full") && !dbFeature.metaData["EX L"].includes("Pony")) {
          dbFeature.metaData["EX L"].push("Pony");
        } else if (dbFeature.metaData["EX L"].includes("Pony") && !dbFeature.metaData["EX L"].includes("Full")) {
          dbFeature.metaData["EX L"].push("Full");
        }
      } else if (!dbFeature.metaData["EX L"] && Array.isArray(dbFeature.metaData["ShowerSize"]) && dbFeature.metaData["ShowerSize"][0] === "30in"
        && Array.isArray(dbFeature.s3Bindings) && dbFeature.s3Bindings[0] && dbFeature.s3Bindings[0].layout === "SM") {
        dbFeature.metaData["EX L"] = ["Full", "Pony"];
      }
    }
    return super.load_(dbFeature, new Threshold())
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive() || !this.getParent().showerFloorIsActive) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      const showerDoorParent = this.getParent().showerDoor;
      if (showerDoorParent && showerDoorParent.activeFeature) {
        const currentShowerPanCondition = showerDoorParent.activeFeature.metaData["ShowerPan"];
        if (!currentShowerPanCondition || (currentShowerPanCondition && !currentShowerPanCondition.includes("Threshold"))) {
          super.hideLayers();
          return;
        }
      }
    }
    const conditions = this.getArrayOfConditions();
    if (!this.shadowFeature || (this.shadowFeature && !this.shadowFeature.matchesMetaForArrayOfConditions(conditions))) {
      this.setShadowFeature();
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const layout = this.getParent().layout;
    const showerSize = this.getParent().showerSize();
    let showerDimensions = getMetadataByDimensions(this.getParent().showerDimensions());

    const vanity = layout.parts[Vanity.id];
    let counterTopSize = vanity.counterTopSize();
    if (counterTopSize === '72in' && layout.type === 1 && (showerDimensions !== "Full" || showerDimensions !== "Pony")) {
      showerDimensions = "Full"
    }

    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }, {
      propName: 'EX L',
      propValue: showerDimensions
    }];
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
      this.setShadowFeature();
    }
  }

  setZIndex(zIndexes) {
    if (this.getParent().activeSubType() === Shower.Type.Custom) {
      const zIndex = zIndexes.Shower.Custom60in.Threshold;
      const zIndex2 = zIndexes.Shower.Custom60in.ThresholdShadow;
      if (zIndexes && this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (zIndexes && this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
      if(zIndexes && this.shadowFeature) {
        this.shadowFeature.layer.zIndex = zIndex2;
      }
    }
  }
}
